module.exports = __webpack_public_path__ + "media/images/receipt/stamp-cc33c60ec2cbb2e0b28c0735af19d76a.png";